export default __webpack_public_path__ + "static/media/notebook-48.02081409.svg";